import SelectModule from "@/store/modules/ramp_modules/base/modules/select";

export default
{
    namespaced : true,
    modules    : { select: SelectModule }
};
